import ShortEnquiry from "./ShortEnquiry"

function QuickDelivery() {
    return (
        <div id='quick-delivery' className='py-10 lg:py-[95px]'>
            <h1 className='text-theme-blue text-center font-[500] text-[28px] capitalize lg:text-[45px] --align'>
                Do you need 
                <span className='text-theme-orange'> quick delivery </span> of APIs at 
                <span className='text-theme-orange'> affordable prices </span> 
                without compromising on 
                <span className='text-theme-orange'> quality </span>?
            </h1>

            <div className='md:text-center'>
                <h5 className='
                        bg-[#F7E6BB] 
                        text-theme-blue 
                        font-[500] 
                        text-center 
                        text-[24px] 
                        mt-[30px] 
                        rounded-[3px]
                        md:inline-block
                        md:px-[10px]
                        lg:text-[22px]
                        lg:mt-[22px]
                    '> 
                    Your are in the right place... 
                </h5>
            </div>

			<ShortEnquiry 
                firstHeading = "Share your"
                secondHeading = "requirement here"
                subText = "and we will find the best deal for you from 4000+ sellers"
            />

            <div className='mt-[40px] md:flex md:justify-between md:items-center --align'>
                <div className='md:w-[50%] lg:w-[43%]'>
                    <img className='w-full md:w-full' src="/Home/QuickDelivery.svg" alt="QuickDelivery" loading='lazy'/>
                </div>

                <div className='mt-[20px] md:w-[40%] lg:w-[48%]'>
                    <h5 className='text-dark-saffron text-[24px] font-semibold lg:text-[36px]'>Guaranteed And Consistent Supply</h5>

                    <p className='text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]'>
                        We understand how crucial a reliable supply of APIs is for you. We take our suppliers' 
                        stock visibility very seriously. Due to our large network, there’s high chance that you 
                        will find the API stock nearby. We even invest in inventory of frequently moving molecules. 
                        We free you, to focus on what you are good at - your business operations.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default QuickDelivery